import { NavItemDef } from './navItems';
import { LEXID_NAV_ITEMS } from './LexID/navItems';
import { POLICY_NAV_ITEMS } from './Policy/navItems';
import { AWB_NAV_ITEMS } from './AWB/navItems';
import { REPORTING_NAV_ITEMS } from './Reporting/navItems';
import { TRAINING_NAV_ITEMS } from './Training/navItems';
import { PERFORMANCE_REPORTING_NAV_ITEMS } from './PerformanceReporting/navItems';

// Function to register all navigation items
export const registerAllNavItems = (registerNavItems: (parentKey: string, items: NavItemDef[]) => void) => {
  // Register navigation items for each module
  registerNavItems('lexid', LEXID_NAV_ITEMS);
  registerNavItems('policy', POLICY_NAV_ITEMS);
  registerNavItems('awb', AWB_NAV_ITEMS);
  registerNavItems('reporting', REPORTING_NAV_ITEMS);
  registerNavItems('training', TRAINING_NAV_ITEMS);
  registerNavItems('performanceReporting', PERFORMANCE_REPORTING_NAV_ITEMS);
};
